// extracted by mini-css-extract-plugin
module.exports = {"overlay":"TourOverlay_overlay__E2_W2","clickBlocker":"TourOverlay_clickBlocker__NpBpX","spotlight":"TourOverlay_spotlight__wkSXL","darkFallback":"TourOverlay_darkFallback__FT3nS"};